import React, { useState, useEffect } from 'react';
import { BiArrowFromLeft, BiArrowFromRight } from 'react-icons/bi';
import { MdGraphicEq } from 'react-icons/md';
import { VscListUnordered } from 'react-icons/vsc';
import { connect } from 'react-redux';
import GroupeEmail from '../../composant/UI/GroupeEmail/GroupeEmail';
import Popup from '../../composant/UI/Popup/Popup';
import AccesRestreins from '../../hoc/AccesRestreins/AccesRestreins';
import { checkMot } from '../../ressources/functionJS/checkMot';
import * as privilege from '../../ressources/glossaires/glossaire_privileges';
import * as type_btn from '../../ressources/glossaires/glossaire_type_de_bouton';
import * as actions from '../../services/actions';
import ConteneurInformation from '../ConteneurInformation/ConteneurInformation';
import Bouton from '../UI/Bouton/Bouton';
import S from './AlarmeAdmin.module.scss';
import Gabarit from './Gabarit/Gabarit';
import FormulaireAlarmeXY from './ProfilAlarmeXY/FormulaireAlarmeXY/FormulaireAlarmeXY';
import ProfilAlarmeXY from './ProfilAlarmeXY/ProfilAlarmeXY';
import TableauAlarmeXY from './TableauAlarmeXY/TableauAlarmeXY';

const AlarmeAdmin = (props) => {
  const [montrerInfo, setMontrerInfo] = useState(false);
  const [montrerInfoFull, setMontrerInfoFull] = useState(false);
  const [indexConteneurInfo, setIndexConteneurInfo] = useState(null);
  const [parametresSelectione, setParametresSelectione] = useState({});
  const [styleConteneurCentralGauche, setStyleConteneurCentralGauche] =
    useState([S.ConteneurCentralGauche]);
  const [styleConteneurCentralDroite, setStyleConteneurCentralDroite] =
    useState([S.ConteneurCentralDroite, S.ConteneurCentralDroiteFermer]);

  //Fonction pour enregistrer les informations de la ligne sélectionné depuis le tableau de Alarmes
  const ligneSelectione = (info) => {
    setParametresSelectione(info);
    setIndexConteneurInfo(indexConteneurInfo.profil);
    setMontrerInfo(true);
  };
  const commutateurInfoCreer = () => {
    if (montrerInfo) {
      //ancien état : conteneur info ouvert ; prochain état fermé -> on désactive full info
      setMontrerInfoFull(false);
    }
    setMontrerInfo((montrerInfo) => !montrerInfo);
  };
  //fonction switch conteneur info full screen
  const commutateurInfoFull = () => {
    setMontrerInfoFull((montrerInfoFull) => !montrerInfoFull);
  };

  //fonction pour refermer le contneur information lors d'une annulation de création
  const commutateurAnnuler = () => {
    // props.ajouterAlerte("warning", "Annuler","Alarmes non créé");
    setMontrerInfo(false);
    setIndexConteneurInfo(null);
  };

  //fonction pour ouverture du conteneur information avec le formulaire de création
  const creerVue = () => {
    setMontrerInfo(true);
    if (indexConteneurInfo?.ajouterForm) {
      setIndexConteneurInfo(indexConteneurInfo.ajouterForm);
    }
  };

  useEffect(() => {
    let styleConteneurCentralGauche = [S.ConteneurCentralGauche];
    let styleConteneurCentralDroite = [S.ConteneurCentralDroite];
    if (montrerInfo) {
      if (montrerInfoFull) {
        styleConteneurCentralDroite.push(S.ConteneurCentralDroiteFull);
        styleConteneurCentralGauche.push(S.ConteneurCentraGaucheVoid);
      } else {
        styleConteneurCentralDroite.push(S.ConteneurCentralDroiteOuvert);
      }
    } else {
      styleConteneurCentralDroite.push(S.ConteneurCentralDroiteFermer);
      styleConteneurCentralGauche.push(S.ConteneurCentraGaucheFermer);
    }

    setStyleConteneurCentralGauche(styleConteneurCentralGauche);
    setStyleConteneurCentralDroite(styleConteneurCentralDroite);
  }, [montrerInfo, montrerInfoFull]);

  return (
    <>
      <div className={[S.ConteneurVue].join(' ')}>
        <div className={styleConteneurCentralGauche.join(' ')}>
          {/*Tableau de vue*/}
          <TableauAlarmeXY projetSelectione={ligneSelectione} creer={creerVue}>
            <AccesRestreins
              listNumPrivilege={[
                privilege.creer_des_gabarits,
                privilege.modifier_des_gabarits,
                privilege.supprimer_des_gabarits,
              ]}
            >
              <Popup
                hoverText={checkMot('gabarit')}
                typeBoutonAffichage={type_btn.outil}
                ajoutOverlay={S.Overlay}
                icone={<MdGraphicEq size={15} />}
              >
                <Gabarit />
              </Popup>
            </AccesRestreins>
            <Popup
              hoverText={checkMot('groupe_email')}
              typeBoutonAffichage={type_btn.outil}
              ajoutOverlay={S.Overlay}
              icone={<VscListUnordered size={15} />}
            >
              <GroupeEmail />
            </Popup>
          </TableauAlarmeXY>
        </div>
        <div className={S.barConteneur}>
          <div className={S.barOnglet}>
            <div className={S.titreOnglet}> {checkMot('alarmes_std')} </div>
            <div className={S.titreOnglet}> {checkMot('alarmes_xy')} </div>
          </div>
        </div>
        <div className={styleConteneurCentralDroite.join(' ')}>
          {/* bouton plein ferme conteneur  info */}
          <Bouton
            ajoutClass={[[S.CommutateurInfo], S.expandTO].join(' ')}
            cliquer={commutateurInfoCreer}
            rond={true}
            type={type_btn.danger}
          >
            <BiArrowFromLeft size={15} />
          </Bouton>
          {/* bouton plein écran */}
          <Bouton
            ajoutClass={S.expand}
            cliquer={commutateurInfoFull}
            rond={true}
            type={type_btn.danger}
          >
            <BiArrowFromRight size={15} />
          </Bouton>
          <ConteneurInformation
            // information du type de conteneur information à afficher
            selectionInfo={indexConteneurInfo}
            // formulaire de création
            ajouterForm={
              <FormulaireAlarmeXY
                ajouterAlerte={props.ajouterAlerte}
                annuler={commutateurAnnuler}
              />
            }
            // formulaire de profil vue
            profil={
              <ProfilAlarmeXY
                infoAlarmeXY={parametresSelectione}
                reqModifier={props.reqModifier}
                reqSupprimer={props.reqSupprimer}
              />
            }
          />
        </div>
      </div>
    </>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    ajouterAlerte: (typeAlerte, titre, corps) =>
      dispatch(actions.ajouterAlerte(typeAlerte, titre, corps)),
    reqSupprimer: (idAlarmeXY) =>
      dispatch(actions.reqSupprimerAlarmesXY(idAlarmeXY)),
  };
};

export default connect(null, mapDispatchToProps)(AlarmeAdmin);
